import React, { createRef, useState, useEffect } from "react";
import { Button, Modal } from 'react-bootstrap';
import { Form, InputGroup } from "react-bootstrap";
import InputGroupText from "react-bootstrap/esm/InputGroupText";

import { Datatable } from '../../../../shared/datatable/Datatable';
import { TextInput } from "../../../../shared/form/FormInput";
import { Validators } from "../../../../shared/utils/Validators";
import { DropdownInputMultiple } from "../../../../shared/form/FormInput";

import { subjectList, subjectAdd, subjectDetail, subjectUpdate, departmentList, userList, programmeList } from "../../../../shared/settings/apiConfig";
import { postApi, putApi } from "../../../../shared/services/apiHelper";

import './Subject.scss';

const Subject = (props) => {
    const dataTable = createRef();

    const getSubjectForm = (subjectName, subjectCode, departmentId, programmeId, assessorId) => {
        return {
            subjectname: { value: subjectName || '', valid: false, error: '', validators: [Validators.required()] },
            subjectcode: { value: subjectCode || '', valid: false, error: '', validators: [Validators.required()] },
            departmentid: { value: departmentId || [], valid: false, error: '', validators: [Validators.required()] },
            programmeid: { value: programmeId || [], valid: false, error: '', validators: [Validators.required()] },
            assessorid: { value: assessorId || [], valid: false, error: '', validators: [Validators.required()] },
        };
    };

    const [subjectForm, setSubjectForm] = useState(getSubjectForm());
    const [departmentListData, setDepartmentListData] = useState([]);
    const [assessorListData, setAssessorListData] = useState([]);
    const [programmeListData, setProgrammeListData] = useState([]);
    const [subjectDetailData, setSubjectDetailData] = useState({});
    const [subjectModal, setSubjectModal] = useState(false);
    const [formValid, setFormValid] = useState(false);
    const [message, setMessage] = useState({type: '', message: ''});
    const [search, setSearch] = useState("");
    const [formLoading, setFormLoading] = useState(false);

    const editAction = (id) => {
        let payload = {
            field: ["id", "subjectname", "subjectcode", "curriculum", "semester", "programmeid", "clientid", "departmentid"]
        };
        postApi(`${subjectDetail}/${id}`, payload).then(async (response) => {
            const data = response.data.data[0];
            openSubjectModal(data);
        }).catch((error) => {
            console.log(error);
        });
    }

    const [config, setConfig] = useState({
        name: 'subjectList',
        url: subjectList,
        columns: [
            { name: 'Department', property: 'departmenttitle', sort: false, width: '250px' },
            { name: 'Program', property: 'programmename', sort: false, width: '200px' },
            { name: 'Subject', property: 'subjectname', sort: false, width: '200px' },
            { name: 'Subject Code', property: 'subjectcode', sort: false, width: '250px' },
            { name: 'Assessors', property: 'assessorname', sort: false, width: '250px' },
            {
                name: '', property: '', columnType: 'actions', width: '150px',
                actions: {
                    header: "",
                    row: [
                        {
                            type: 'edit',
                            action: editAction
                        }
                    ]
                }
            },
        ],
        field: ["id", "subjectname", "subjectcode", "curriculum", "semester", "programmename", "assessorname", "departmentid", "departmenttitle"],
        filter: [],
        sort: [{ "field": "id", "direction": "asc" }],
        pagination: true,
    });

    useEffect(() => {
        setFormValid(Validators.validateForm(subjectForm));
    }, [subjectForm]);

    const inputChange = (type, value) => {
        const numericFields = ['mobile'];

        if (numericFields.includes(type)) {
            value = value.replace(/\D/g, '');
        }

        setSubjectForm(prevState => {
            return {
                ...prevState,
                [type]: Validators.validateFormControl(prevState[type], value)
            }
        })
    };

    const openSubjectModal = (data) => {
        Promise.all([getDepartmentList(), getProgrammeList(), getAssesserList()]).then((responses) => {
            let departmentData = responses[0].map((data) => {
                return { id: data.id, value: data.title };
            });
            let programmeData = responses[1].map((data) => {
                return { id: data.id, value: data.programmename };
            });
            let assesserList = responses[2].map((data) => {
                let name = data.firstname + " " + data.lastname
                return { id: data.id, value: name };
            });
            setDepartmentListData(departmentData);
            setProgrammeListData(programmeData);
            setAssessorListData(assesserList);

            if ( data ) {
                setSubjectDetailData(data);
                const formData = getSubjectForm(data.subjectname, data.subjectcode, data.departmentid.split(',').map(elem => parseInt(elem)), data.programmeid.split(',').map(elem => parseInt(elem)), data.clientid.split(',').map(elem => parseInt(elem)));
                for (let key in formData) {
                    formData[key] = Validators.validateFormControl(formData[key], formData[key].value)
                }
                setSubjectForm(formData);
            } else {
                setSubjectForm(getSubjectForm());
            }
    
            setSubjectModal(true);
        });
    };

    const closeSubjectModal = () => {
        setSubjectModal(false);
        setSubjectForm(getSubjectForm());
        setDepartmentListData([]);
        setProgrammeListData([]);
        setAssessorListData([]);
        setSubjectDetailData({});
    };

    const getDepartmentList = () => {
        // TODO check do we need to list only user department.
        let payload = {
            field: ["id", "phonenumber", "adminname", "locationtitle", "locationid", "title"],
        };
        return new Promise((resolve, reject) => {
            postApi(departmentList, payload).then(response => {
                resolve(response.data.data);
            }).catch((error) => {
                reject(error);
            });
        })
    };

    const getProgrammeList = () => {
        let payload = {
            filter: []
        };
        return new Promise((resolve, reject) => {
            postApi(programmeList, payload).then((response) => {
                resolve(response.data.data);
            }).catch(error => {
                reject(error);
            });
        })
    };

    const getAssesserList = () => {
        let payload = {
            field: ['rolename', "id", "lastname", "firstname", "departmentid", "roleid"],
            filter: [{ field: "roleid", value: 4, join: "AND", op: "=" }]
        }
        return new Promise((resolve, reject) => {
            postApi(userList, payload).then(response => {
                resolve(response.data.data);
            }).catch((error) => {
                reject(error)
            })
        })
    }

    const addOrUpdateSubject = (edit, addAnotherSubject=false) => {

        let data = {
            "subjectname": subjectForm.subjectname.value,
            "subjectcode": subjectForm.subjectcode.value,
            "departmentid": subjectForm.departmentid.value,
            "programmeid": subjectForm.programmeid.value,
            "assessorid": subjectForm.assessorid.value
        };
        setFormLoading(true)

        if (edit) {
            data["id"] = subjectDetailData.id
            putApi(subjectUpdate, { data }).then((response) => {
                setMessage({type: 'success', message: "Subject Updated Successfully"});

                dataTable.current?.searchData([]);

                setTimeout(() => {
                    setFormLoading(false)
                    closeSubjectModal();
                    setMessage({type: '', message: ""});
                }, 2000);

            }).catch((error) => {
                setMessage({type: 'error', message: error.message});
                setTimeout(() => {
                    setFormLoading(false)
                    setMessage({type: '', message: ''});
                }, 2000);
            })
        } else {
            postApi(subjectAdd, { data }).then((response) => {

                setMessage({type: 'success', message: "Subject Added Successfully"});

                dataTable.current?.searchData([]);

                if ( addAnotherSubject ) {
                    setSubjectForm(getSubjectForm());
                }

                setTimeout(() => {
                    if ( !addAnotherSubject ) {
                        closeSubjectModal();
                    }
                    setFormLoading(false)
                    setMessage({type: '', message: ""});
                }, 2000);

            }).catch((error) => {
                setMessage({type: 'error', message: error.message});
                // setErrorMessage(error.response?.data?.message[0]?.message ? error.response?.data?.message[0]?.message : error.response?.data?.message);
                setTimeout(() => {
                    setFormLoading(false)
                    setMessage({type: '', message: ''});
                }, 2000);
            })
        }
    }

    const clearData = () => {
        setSearch("");
        dataTable.current?.searchData([
            { field: 'subjectname', value: "", op: 'LIKE', 'join': 'OR' },
            { field: 'subjectcode', value: "", op: 'LIKE', 'join': 'OR' },
            { field: 'departmenttitle', value: "", op: 'LIKE', 'join': 'OR' },
        ])
    }

    return (
        <div>
            <div className="subjects w-100">
                <text className='screen-head'>Subjects</text>
            <div className="d-flex w-100 p-3 justify-content-between">
                <div>
                    {/* <text className="text-primary">Subject List</text> */}
                </div>
                <div className="d-flex gap-2 rightcont width-60">
                    <InputGroup className="">
                        <InputGroupText className=" search" >
                            <i class="fa fa-search ml-3" ></i>
                        </InputGroupText>

                        <span class="icon-envelope-o"></span>

                        <Form.Control className={`search `} type={'text'} style={{ borderRadius: '0px 5px 5px 0px', borderLeft: 'none' }} name={"search"} placeholder={"search  by subject name/code or department name "}
                            onChange={(event) => { 
                                setSearch(event.target.value);
                                
                                // TODO check if already had a filter
                                if (event.target.value.length == 0) {
                                    dataTable.current?.searchData([]);
                                }
                            }}
                            value={search}
                            onKeyPress={(event) => {
                                if (event?.key === "Enter" && search)
                                    dataTable.current?.searchData([
                                        { field: 'subjectname', value: search, op: 'LIKE', 'join': 'OR' },
                                        { field: 'subjectcode', value: search, op: 'LIKE', 'join': 'OR' },
                                        { field: 'departmenttitle', value: search, op: 'LIKE', 'join': 'OR' },
                                    ])
                            }} />

                    </InputGroup>
                    <button type="button" className="btn btn-secondary subj-btn" onClick={() => {clearData()}}>Clear</button>
                    <button type="button" onClick={() => { openSubjectModal(); }} className="btn btn-primary w-50 subj-btn" >Add Subjects</button>
                </div>
            </div>
</div>
            <div style={{ padding: '15px' }}>
                <Datatable ref={dataTable} config={config} />
            </div>

            <Modal className="departments" show={subjectModal} onHide={closeSubjectModal} size="lg" centered backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title className="text-primary" style={{ fontWeight: 'bold' }}>{subjectDetailData.id ? "Update Subject" : "Add Subject"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <div className="d-flex flex-column w-100 gap-3">
                        <div className="d-flex gap-3">
                            <TextInput type={'text'} name={'subjectname'} label={'Subject Name'} placeholder={'Subject Name'} isMandatory={true}
                                value={subjectForm.subjectname.value} error={subjectForm.subjectname.error} onChange={(event) => inputChange("subjectname", event.target.value)} />

                            <TextInput type={'text'} name={'subjectcode'} label={'Subject Code'} placeholder={'Subject Code'}  isMandatory={true}
                                value={subjectForm.subjectcode.value} error={subjectForm.subjectcode.error} onChange={(event) => inputChange("subjectcode", event.target.value)} />
                        </div>

                        <div className="d-flex gap-3">
                            <div style={{flex: '1 0', }}>
                                {/** TODO move this label to TextInput.js */}
                                <Form.Label className="form-label">Department <span className="text-danger">*</span></Form.Label>
                                <DropdownInputMultiple placeholder="Select Department" value={subjectForm.departmentid.value} data={departmentListData}  name={'department'} onChange={(data) => { inputChange('departmentid', data); }} />
                            </div>

                            <div style={{flex: '1 0', }}>
                                {/** TODO move this label to TextInput.js */}
                                <Form.Label className="form-label">Programme <span className="text-danger">*</span></Form.Label>
                                <DropdownInputMultiple label={'Program'} placeholder="Select Program" value={subjectForm.programmeid.value} data={programmeListData} name={'program'} onChange={(data) => { inputChange('programmeid', data); }} />
                            </div>
                            
                        </div>

                        <div>
                            {/** TODO move this label to TextInput.js */}
                            <Form.Label className="form-label">Assessor <span className="text-danger">*</span></Form.Label>
                            <DropdownInputMultiple label={'Assesser'} name={'assesser'} value={subjectForm.assessorid.value} placeholder="Select Assessor" data={assessorListData} onChange={(data) => { inputChange('assessorid', data); }} />
                        </div>

                    </div>
                    <div style={{ padding: '0px 20px 0px 20px' }}>

                        <div className="mt-5" style={{ textAlign: 'center', width: '100%' }}>
                            <p style={{ color: message.type === 'success' ? 'green' : '#A50050' }}>{message.message}</p>
                        </div>
                    </div>


                </Modal.Body>
                <Modal.Footer className="d-flex" style={{ justifyContent: 'center' }}>
                    {
                        subjectDetailData.id ?
                        <Button className="subjectForm-button" disabled={!formValid  || formLoading} onClick={() => addOrUpdateSubject(true)}>Update Subject </Button> :
                        <>
                            <Button className="subjectForm-button" disabled={!formValid || formLoading} onClick={() => addOrUpdateSubject(false, true)}>Create Subjects and Add Another</Button>
                            <Button className="subjectForm-button" onClick={() => addOrUpdateSubject(false)} disabled={!formValid  || formLoading}>Create Subjects </Button>
                        </>
                    }
                </Modal.Footer>
            </Modal>

        </div>
    );
}

export default Subject;
